export default "__VITE_ASSET__Bqu2I3oC__"